export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'all',
    name: '全部漫画',
    description: '5177漫画网全站漫画作品，涵盖恋爱、校园、奇幻、都市、悬疑等热门题材',
    icon: 'ri-apps-2-line',
  },
  {
    slug: 'romance',
    name: '恋爱',
    description: '甜蜜浪漫的恋爱韩漫合集，包括《帐篷里的秘密》《温柔禁区》等高分作品',
    icon: 'ri-heart-3-line',
  },
  {
    slug: 'school',
    name: '校园',
    description: '青春校园题材韩漫，热血、初恋与成长都在这里发生',
    icon: 'ri-graduation-cap-line',
  },
  {
    slug: 'fantasy',
    name: '奇幻',
    description: '剑与魔法、妖怪契约、异世界冒险，想象力爆棚的奇幻韩漫',
    icon: 'ri-sparkling-2-line',
  },
  {
    slug: 'urban',
    name: '都市',
    description: '都市生活、商战逆袭、深夜温情，贴近现实的都市韩漫',
    icon: 'ri-building-2-line',
  },
  {
    slug: 'mystery',
    name: '悬疑',
    description: '烧脑推理、时间谜局、迷雾侦探，让大脑停不下来的悬疑韩漫',
    icon: 'ri-search-eye-line',
  },
];

export function getCategory(slug: string): Category {
  return categories.find((c) => c.slug === slug) ?? categories[0];
}